import { render, staticRenderFns } from "./MatchDistribution.vue?vue&type=template&id=78d777c2&scoped=true&"
import script from "./MatchDistribution.vue?vue&type=script&lang=js&"
export * from "./MatchDistribution.vue?vue&type=script&lang=js&"
import style0 from "./MatchDistribution.vue?vue&type=style&index=0&id=78d777c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d777c2",
  null
  
)

export default component.exports